'use client';
/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';
import { Box, Center, Flex, Grid, GridItem, Text } from '@chakra-ui/react';

import { render } from 'datocms-structured-text-to-html-string';
/* Internal Imports */
/* Components */
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';

/* Services */

// Card component to handle common styles and structure
const Card = ({ card, region, lang }) => (
  <Box
    minH="120px"
    height={{ md: '120px', lg: '152px' }}
    // border={"2px solid orange"}
    p={{
      lg: '45px 56px 0px 56px',
      md: '20px 24px 20px 24px',

      base: '0px 24px 0px 24px',
    }}
    background={`linear-gradient(to right, rgba(96, 173, 255, 0), rgba(57, 105, 156, 0.3), rgba(96, 173, 255, 0))`}
    mb="8px"
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
  >
    <Box
      fontSize={{ lg: '20px', base: '16px' }}
      // border={"2px solid yellow"}
      width={{ md: 'auto', lg: '100%' }}
      color="#FEFAF6"
      letterSpacing="2%"
      fontFamily="var(--FedraSansStd-medium)"
      fontWeight={500}
      lineHeight={{ lg: '32px', md: '25.6px', base: '28.6px' }}
      textAlign="center"
    >
      {card.title}
    </Box>

    <StructuredTextParser
      textAlign="center"
      opacity="75%"
      fontSize={{ lg: '18px', base: '14px' }}
      color="#FEFAF6"
      fontFamily="var(--FedraSansStd-book)"
      fontWeight={350}
      lineHeight={{ lg: '28.8px', base: '22.4px' }}
      str={render(card.description)}
      region={region}
      lang={lang}
      mb={{ lg: '10' }}
    />
  </Box>
);

/**
 *

 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 */
const AwardsAchievements = ({ sectionContent, region, lang }) => {
  const [activeCards, setActiveCards] = useState(sectionContent[1]?.cards);

  return (
    <Box
      background="#000"
      maxW="1472px"
      minW="320px"
      paddingTop={{ md: '10%', lg: '10rem' }}
      mx="auto"
      objectFit="contain"
      p="4"
      pb={{ base: '100px', md: '10%', lg: '5rem' }}
    >
      <Flex
        justifyContent={{ md: 'space-between' }}
        flexDirection="row"
        marginX={{ lg: '3rem' }}
        gap={{ base: '8' }}
        alignItems={'center'}
        mb={'8px'}
      >
        <Box pb="24px" mt={4} ml="5px" color="#FEFAF6">
          <Box
            as="span"
            fontSize={{ base: '24px', md: '28px', lg: '36px' }}
            lineHeight={{ base: '28.8px', md: '33.6px', lg: '43.2px' }}
            fontFamily="var(--FedraSerifDisplay-Regular)"
            fontWeight={400}
            color={'#FEFAF6'}
            letterSpacing="0.16px"
          >
            {sectionContent[0]?.titleText}
          </Box>
          <Box
            as="span"
            color={'#60ADFF'}
            fontSize={{ base: '24px', md: '28px', lg: '36px' }}
            lineHeight={{ base: '28.8px', md: '33.6px', lg: '43.2px' }}
            fontFamily="var(--FedraSerifDisplay-Bold)"
            letterSpacing="0.16px"
          >
            {sectionContent[0]?.titleSubtext}
          </Box>
        </Box>

        <Link
          href={refineUrlDomain(sectionContent[2]?.linkUrl, region, lang)}
          prefetch
        >
          <Text
            fontSize={{ md: '16px' }}
            fontFamily="var(--FedraSansStd-book)"
            fontWeight={500}
            lineHeight={{ md: '25.6px' }}
            mr="5px"
            _hover={{
              color: '#80BDFF',
            }}
            mb={2}
            display={{ base: 'none', md: 'block' }}
            // color="rgba(96, 173, 255, 1)"
            color="#F1EDE9"
          >
            {sectionContent[2]?.buttonText}
            <ArrowForwardIcon ml="5px" boxSize={5} mb={0.5} />
          </Text>
        </Link>
        <Center
          ml="5px"
          boxSize="48px"
          borderRadius="full"
          // bg="rgba(96, 173, 255, 0.2)"
          bg="#1A1D1F"
          // _hover={{
          //   bg: '#80BDFF', // Sets the background color on hover
          // }}
          display={{ base: 'flex', md: 'none' }}
          position="absolute"
          right="4"
        >
          <Link
            href={refineUrlDomain(sectionContent[2]?.linkUrl, region, lang)}
          >
            <ArrowForwardIcon
              boxSize="24px"
              // color="rgba(96, 173, 255, 1)"
              color={'#F1EDE9'}
              _hover={{
                color: '#80BDFF', // Sets the background color on hover
              }}
            />
          </Link>
        </Center>
      </Flex>

      <Grid
        templateColumns={{ base: '1fr', md: '1fr 1fr ' }}
        gap="8px"
        // border={{
        //   base: '2px solid red',
        //   md: '2px solid green',
        //   lg: '2px solid blue',
        // }}
      >
        {activeCards?.map((card, index) => (
          <GridItem key={index}>
            <Card card={card} region={region} lang={lang} />
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};

export default AwardsAchievements;
